// extracted by mini-css-extract-plugin
export default {"pageTitle":"PageTitle-pageTitle-yXS","pageTitleHasChildren":"PageTitle-pageTitleHasChildren-QrW"};